import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { CadastroCartoes } from '../CadastroCartoes';
import './style.css';
import P from 'prop-types';
//import { Button } from '../../Button';
import { ExcluirCartao, GetCartoes } from '../../../utils/api/api';
import { GlobalContext } from '../../../contexts/HomeContext';
import { Modal } from '../../Modal';
import { toast } from 'react-toastify';

export const ListaCartoesCredito = ({ param }) => {
  const { dadosApp, user } = useContext(GlobalContext);
  const [isCadastro, setIsCadastro] = useState(false);
  const [modalLoading, setModalLoading] = useState('block');
  const [cartoes, setCartoes] = useState([]);
  const itemEls = useRef({});

  const dadosCartao = useMemo(() => {
    return {
      cliente: {
        codigo: user.id,
        nome: user.nome,
        sobrenome: user.sobrenome,
        nomeCompleto: user.nome_completo,
        email: user.email,
        tipoDocumento: 'CPF',
        numeroDocumento: user.cpf,
        ddd: user.telefone_ddd,
        telefone: user.telefone,
      },
      cartao: {
        numeroCartao: '',
        nomeImpresso: '',
        mesExpiracao: '',
        anoExpiracao: '',
        codigoSeguranca: '',
        cpf: '',
        tokenCard: '',
      },
      empresa: {
        idLoja: dadosApp.IdLoja,
        fantasia: dadosApp.Empresa.Empresa.fantasia,
        razaoSocial: dadosApp.Empresa.Empresa.razao,
      },
    };
  }, [user, dadosApp]);

  const showHideLoading = useCallback(() => {
    setModalLoading(modalLoading == 'none' ? 'block' : 'none');
  }, [modalLoading]);

  const handleGetCartoes = useCallback(async () => {
    const resp = await GetCartoes(dadosCartao);
    setModalLoading('none');
    if (resp.data.status == 'ok') setCartoes(resp.data.result);
  }, [dadosCartao]);

  const handleShowOptions = (element) => {
    element.style.display == 'block' ? (element.style.display = 'none') : (element.style.display = 'block');
  };

  const handleDeleteCard = async (cartao) => {
    if (cartao.id > 0) {
      showHideLoading();

      let obj = dadosCartao;
      obj.cartao = {
        numeroCartao: cartao.cartao_numero,
        nomeImpresso: cartao.nome_completo_cartao,
        mesExpiracao: cartao.cartao_validade.substring(5, 7).replace('-', ''),
        anoExpiracao: cartao.cartao_validade.substring(0, 4).replace('-', ''),
        codigoSeguranca: cartao.cartao_codigo_seguranca,
        cpf: cartao.cpf,
        //tokenCard: cartao.tokenCard,
      };

      const response = await ExcluirCartao(dadosCartao);
      setModalLoading(false);

      if (response.data.Retorno) {
        if (response.data.Retorno.status === 1) {
          toast.error(response.data.Retorno.msg.toString(), { containerId: 'modalToast' });
          return;
        }
      } else {
        if (response.data.status === 'error') {
          toast.error(response.data.retornoMensagem, { autoClose: 3000 });
          return;
        }
      }
      handleGetCartoes();
      toast.success('Cartão excluído com sucesso');
    }
  };

  const handleNewBack = (reload = false) => {
    setIsCadastro(!isCadastro);
    if (reload) handleGetCartoes();
  };

  const handleSelected = (cartao) => {
    if (!param.isFinalizacao) return;
    cartao.tokenCard = cartao.cartao_numero;

    param.setPagOnlineSelecionado(cartao);
    setTimeout(() => {
      param.closeModal();
    }, 150);
  };

  useEffect(() => {
    handleGetCartoes();
  }, [handleGetCartoes]);

  return (
    <>
      <div className="modal-content-dialog padTop20 " style={{ borderTop: 'none', marginBottom: 20 }}>
        {/* <Button
          className="btnWhite btn-shadow"
          text={`${isCadastro ? 'Cartões' : 'Adicionar Novo Cartão'}`}
          icon={`${isCadastro ? 'chevron_left' : 'add'}`}
          iconAlign={`${isCadastro ? 'left' : 'right'}`}
          onClick={() => handleNewBack()}
        /> */}

        {!isCadastro && param.isFinalizacao && cartoes.length > 0 && (
          <h4 style={{ fontSize: '1.25rem', textAlign: 'center', marginBottom: '20px' }}>Selecione algum cartão</h4>
        )}
        {/* {cartoes.length == 0 && !isCadastro && !param.isFinalizacao && ( */}
        {cartoes.length == 0 && !isCadastro && (
          <h4 style={{ fontSize: '1.25rem', textAlign: 'center', marginBottom: '20px' }}>Nenhum Cartão Cadastrado</h4>
        )}

        {!isCadastro && cartoes.length > 0 && (
          <div className="cardShadow">
            {cartoes.map((cartao, index) => (
              <div
                key={cartao.id}
                className="btnWhite btn-shadow"
                onClick={() => handleSelected(cartao)}
                style={{ display: 'inline-table', padding: '10px 15px', marginBottom: '10px' }}
              >
                {!param.isFinalizacao && (
                  <>
                    <div ref={(el) => (itemEls.current[index] = el)} style={{ display: 'none', float: 'left' }}>
                      <span
                        style={{ margin: '0 10px 0 0', color: '#e54750', cursor: 'pointer', float: 'left' }}
                        onClick={() => handleDeleteCard(cartao)}
                      >
                        <i className="material-icons">clear</i>
                      </span>
                    </div>
                    <span
                      style={{ margin: '0 -10px 0 5px', color: '#e54750', cursor: 'pointer', float: 'right' }}
                      onClick={() => handleShowOptions(itemEls.current[index])}
                    >
                      <i className="material-icons">more_vert</i>
                    </span>
                  </>
                )}
                <p
                  style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#000000',
                    marginBottom: '15px',
                    textAlign: 'right',
                  }}
                >
                  <span style={{ fontWeight: 'normal' }}>{`**** \u00A0 **** \u00A0 **** \u00A0`}</span>
                  {cartao.cartao_nome}
                </p>
                <div>
                  <p
                    className="ellipsis"
                    style={{ fontSize: '14px', margin: '0', color: '#000000', display: 'flex-root' }}
                  >
                    {cartao.nome_completo_cartao.toUpperCase()}
                    <span style={{ float: 'right' }}>{`${cartao.cartao_validade.replace('-', '/')}`}</span>
                    {/* <span style={{ float: 'right' }}>{`${cartao.cartao_validade.substring(
                    5,
                    7,
                  )}/${cartao.cartao_validade.substring(0, 4)}`}</span> */}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {isCadastro && <CadastroCartoes handleNewBack={handleNewBack} />}

      {modalLoading === 'block' && (
        <Modal
          title=""
          isFooter={false}
          visibility={modalLoading}
          param={{ msg: 'Aguarde...' }}
          page="LOADING"
          customPosition="loading-modal"
        />
      )}
    </>
  );
};

ListaCartoesCredito.propTypes = {
  param: P.object,
};
